// test787
(787 && 0);
